import { RBfuncs } from './ReplyBoxFuncs';
import { EditorState, Modifier, SelectionState } from 'draft-js';
import TemplateTags from 'services/template-tags';

export const isEmailThread = (
  availableChannels,
  recipientChannelId,
  hasFeatureEnabled = false
) => {
  const selectedChannel = availableChannels.find((channel) => {
    return channel.id === recipientChannelId;
  });

  if (!selectedChannel) {
    return false;
  }

  const isEmailChannel = selectedChannel.type === 'mailgun';

  return isEmailChannel && hasFeatureEnabled;
};

export const insertImageLink = (
  editorState,
  editorMode,
  links,
  onEditorStateChange
) => {
  const newEditorState = RBfuncs.insertImageLink(
    links,
    editorMode,
    editorState
  );
  const newNEditorState = RBfuncs.cursorToBlockEnd(newEditorState);
  onEditorStateChange(newNEditorState);
};

const getTagLocations = (text, regex) => {
  let matchArr, start;
  let tagLocations = [];
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;
    tagLocations.push([start, start + matchArr[0].length]);
  }
  return tagLocations;
};

export const replaceTemplateTags = (editorState, templateContext) => {
  // We want the cursor to go at the end of the inserted tag only if the tag was manually typed, pasting/saved replies should still go to the end of their content
  const shouldMoveCursor =
    editorState.getLastChangeType() === 'insert-characters';
  let newEditorState = editorState;
  const formatTagRegex = `{{#[^}}]*}}.*{{\/[^}}]*}}`;
  const regularTagRegex = `{{[^}}]*}}`;
  const templateTagRegex = new RegExp(
    `${formatTagRegex}|${regularTagRegex}`,
    'g'
  );
  const contentMatchesTemplateTag = editorState
    .getCurrentContent()
    .getPlainText()
    .match(templateTagRegex);

  if (contentMatchesTemplateTag) {
    const blockArray = editorState.getCurrentContent().getBlocksAsArray();
    newEditorState = blockArray
      .map((b) => b.toJS())
      // Loop over each block
      .reduce((newEditorState, { key, text }) => {
        // Find all the template tags in the block
        const tagLocations = getTagLocations(text, templateTagRegex);
        // For each template tag replace it with the actual content
        const { editorStateWithTagsReplaced } = tagLocations.reduce(
          ({ editorStateWithTagsReplaced, cumulativeOffset }, [start, end]) => {
            // Grab the tag
            const tag = text.slice(start, end);
            const newText = TemplateTags(tag, templateContext);
            const textLengthChange = newText.length - tag.length;
            const newOffset = cumulativeOffset + textLengthChange;
            // Create a selection for the template tag to be replaced
            const selectionState = SelectionState.createEmpty().merge({
              anchorKey: key,
              focusKey: key,
              anchorOffset: start + cumulativeOffset,
              focusOffset: end + cumulativeOffset,
            });
            // Replace the tag with the new text
            const newContent = Modifier.replaceText(
              editorStateWithTagsReplaced.getCurrentContent(),
              selectionState,
              newText
            );
            if (shouldMoveCursor) {
              // Move the cursor to the end of the replaced text
              return {
                editorStateWithTagsReplaced: EditorState.forceSelection(
                  EditorState.push(
                    editorStateWithTagsReplaced,
                    newContent,
                    'template-tag'
                  ),
                  selectionState.merge({
                    focusOffset:
                      selectionState.getAnchorOffset() + newText.length,
                    anchorOffset:
                      selectionState.getAnchorOffset() + newText.length,
                    hasFocus: true,
                  })
                ),
                cumulativeOffset: newOffset,
              };
            } else {
              // Move the cursor to the end of the block
              return {
                editorStateWithTagsReplaced: EditorState.moveFocusToEnd(
                  EditorState.push(
                    editorStateWithTagsReplaced,
                    newContent,
                    'template-tag'
                  )
                ),
                cumulativeOffset: newOffset,
              };
            }
          },
          { editorStateWithTagsReplaced: newEditorState, cumulativeOffset: 0 }
        );
        return editorStateWithTagsReplaced;
      }, newEditorState);
  }
  return newEditorState;
};
